import { grey } from '@material-ui/core/colors';
import { createStyles, Theme } from '@material-ui/core/styles';
import { StyleRules } from '@material-ui/core/styles/withStyles';

const styles = (theme: Theme): StyleRules<string> => createStyles({
  root: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  userProfileText: {
    paddingLeft: theme.spacing(1),
  },
  menuPopoverRoot: {
    pointerEvents: 'none',
  },
  menuItem: {
    minWidth: 150,
    display: 'flex',
  },
  menuItemIcon: {
    marginRight: theme.spacing(1),
    color: grey[600],
  },
});

export default styles;
